<template>
  <div id="app">
    <div class="info">
      <p id="state" v-if="state">{{ state }}</p>
      <p id="errMsg" v-if="errMsg">{{ errMsg }}</p>
    </div>
    <h1>Firebase data</h1>
    <div><span>Data:</span> {{ firebaseData }}</div>
    <hr />

    <h1>Form data</h1>
    <div><span>Data:</span> {{ formData }}</div>
    <hr />

    <form @submit.prevent="updateFirebase" @input="debouncedUpdate">
      <label for="name"
        >Name:
        <input type="text" name="name" v-model="formData.name" />
      </label>
      <label for="email"
        >Email:
        <input type="email" name="email" v-model="formData.email" />
      </label>
      <label for="tel"
        >Phone:
        <input type="tel" name="tel" v-model="formData.tel" />
      </label>
      <!-- <button type="submit">Submit</button> -->
    </form>
    <button @click="revokeChanges" :disabled="!originalData">
      Revoke changes
    </button>
  </div>
</template>

<script>
// import * as debounce from 'debounce';
import { debounce } from "debounce";
import { doc, getDoc, onSnapshot, setDoc } from "@firebase/firestore";
import { db } from "./firebase";

const docRef = doc(db, "contacts", "ali");

const LOADING = "Loading..";
const SYNCED = "Synced";
const ERR_LOADING_DATA = "Error loading data!";

export default {
  name: "App",
  data() {
    return {
      originalData: null,
      firebaseData: null,
      formData: {},
      state: null,
      errMsg: null,
    };
  },
  created() {
    this.getFirestoreData();
    this.getFirestoreDataOnChange();
  },
  methods: {
    // Initial update
    getFirestoreData() {
      this.state = LOADING;

      getDoc(docRef)
        .then((snapshot) => {
          if (snapshot.exists()) {
            const data = snapshot.data();

            this.originalData = { ...data };
            this.formData = data;
            this.state = SYNCED;
          }
        })
        .catch((err) => {
          this.state = ERR_LOADING_DATA;
          console.log(err.message);
        });
    },
    // Update on real time changes on DB
    getFirestoreDataOnChange() {
      onSnapshot(
        docRef,
        (doc) => {
          if (doc.exists()) this.firebaseData = doc.data();
        },
        (err) => console.error(err.message)
      );
    },
    // Post changes
    async updateFirebase() {
      try {
        this.errMsg = null;
        this.state = LOADING;
        await setDoc(docRef, this.formData);
        this.state = SYNCED;
      } catch (err) {
        this.state = ERR_LOADING_DATA;
        this.errMsg = err.message;
        console.error(err.message);
      }
    },
    // Delay the update by 1.5s after last change.
    debouncedUpdate: debounce(function () {
      this.updateFirebase();
    }, 1500),
    // Revoque the changes after the last reload of the page.
    revokeChanges() {
      if (this.originalData) {
        this.formData = this.originalData;
        this.updateFirebase();
      }
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
form {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
label {
  margin: 1rem 0;
  display: flex;
  align-items: center;
  width: 230px;
}
input {
  height: 1.3rem;
  margin-left: auto;
}
button {
  width: 100%;
  height: 2rem;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  width: 230px;
}
.info {
  margin-bottom: 1rem;
}
#errMsg {
  color: red;
}
</style>
